module.exports = __webpack_public_path__ + "static/media/about.8b06c3fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/mengduo/about.svg
// module id = 152
// module chunks = 6